if (!customElements.get('etab-slider')) {
  class EtabSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.etab-slider__slide'));
      this.currentEl = this.querySelector('[data-slider-current]');
      this.progressBar = this.querySelector('[data-slider-progress]');
      this.current = 0;

      const viewport = this.querySelector('[data-slider-viewport]');
      const prevBtn = this.querySelector('[data-slider-prev]');
      const nextBtn = this.querySelector('[data-slider-next]');

      if (prevBtn) prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.goTo(this.current + 1));

      let startX = 0;
      viewport.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', (e) => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) this.goTo(diff > 0 ? this.current + 1 : this.current - 1);
      }, { passive: true });

      this.querySelectorAll('[data-expand-toggle]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const popup = btn.closest('.etab-slider__slide').querySelector('[data-expand-popup]');
          const isOpen = popup.classList.contains('is-open');
          this.closePopups();
          if (!isOpen) {
            popup.classList.add('is-open');
            btn.classList.add('is-active');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closePopups();
      });
    }

    goTo(index) {
      const total = this.slides.length;
      index = ((index % total) + total) % total;
      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.slides[index].classList.add('is-active');
      this.slides[index].removeAttribute('aria-hidden');
      this.current = index;
      if (this.currentEl) this.currentEl.textContent = index + 1;
      if (this.progressBar) this.progressBar.style.width = ((index + 1) / total * 100) + '%';
      this.closePopups();
    }

    closePopups() {
      this.querySelectorAll('.etab-slider__popup.is-open').forEach((p) => p.classList.remove('is-open'));
      this.querySelectorAll('.etab-slider__expand.is-active').forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-expanded', 'false');
      });
    }
  }

  customElements.define('etab-slider', EtabSlider);
}
